<template>
    <div class="projectList">
        <helpInfo :helpData='helpData'
                  style="background: #fff;"></helpInfo>
        <div class="content">
            <!-- 卡片模式 -->
            <div style="position: relative;"
                 class="top">
                <div class="ope-pack">
                    <div>
                        <Button @click="refresh"
                                class="refresh">
                            <i class="icon-refresh-o-2"></i>
                        </Button>
                        <!-- <Button type="primary"
                                style="margin:0 0 0 6px;"
                                @click="create"
                                :disabled="!hasPermission('CH0402')"
                                slot="tootipL">
                            <i class="icon-plus-o-1"></i>{{$t('创建')}}
                        </Button> -->
                    </div>
                    <div class="searchInput">
                        <i-input v-model="searchName"
                                 :placeholder="$t('搜索')">
                            <Select v-model="searchCondition"
                                    slot="prepend"
                                    style="width: 100px;">
                                <Option :key="i"
                                        v-for="(item,i) in searchList"
                                        :value="item.value">{{ item.label }}</Option>
                            </Select>
                            <i-button slot="append"
                                      icon="table-search icon-search-o"
                                      @click="searchClick"></i-button>
                        </i-input>
                    </div>
                </div>
                <!-- 查询标签 -->
                <div v-show="searchValueList[0].name!==''"
                     class="search-tips-card">
                    <Tag type='border'
                         v-for="(item,index) in searchValueList"
                         closable
                         color='primary'
                         :key='index'
                         @on-close='handleCloseTags(index)'>{{$t('项目名称')+'：'+item.name}}</Tag>
                </div>

                <!-- 卡卡模式 - 内容 -->
                <div class="card">
                    <div class="cardRow">
                        <Row v-if="!loading"
                             :gutter="15">
                            <Col v-for="(item, index) in projectList"
                                 :key="index"
                                 style="padding-bottom: 15px;"
                                 span="6">
                            <Card class="no-pad card-main tbl-operate">
                                <p slot="title"
                                   @click="cardClick(item)"
                                   class="rc-ellipsis title"
                                   style="font-size: 12px"
                                   :title="item.orgName">
                                    {{$t(item.orgName)}}
                                </p>
                                <span class="operatingBtn">
                                    <a slot="extra"
                                       v-if="item.orgCode!=='default'"
                                       :disabled="!hasPermission('CH0403')"
                                       :title="$t('编辑')"
                                       @click="editClick(item)">
                                        <i class="icon-edit"></i></a>
                                    <a slot="extra"
                                       :title="$t('设置')"
                                       :disabled="!hasPermission('CH0404')"
                                       @click="setClick(item)">
                                        <i class="icon-personal-settings-o"
                                           style="font-weight: 700;"></i></a>
                                    <a slot="extra"
                                       v-if="item.orgCode!=='default'"
                                       :title="$t('删除')"
                                       :disabled="!hasPermission('CH0405')"
                                       :style="item.orgCode==='default'?'':'color:#f00'"
                                       @click="deleteClick(item)">
                                        <i class="icon-delete"></i></a>
                                </span>
                                <div class="card-content"
                                     @click="cardClick(item)">
                                    <ul>
                                        <li class="rc-ellipsis"
                                            :title="$t('创建时间')+':'+(item.createdDt||'--')">{{$t('创建时间')}}：<span>{{item.createdDt||'--'}}</span> </li>
                                        <li class="rc-ellipsis"
                                            :title="$t('项目描述')+':'+(item.description||'--')">{{$t('项目描述')}}：<span>{{item.description||'--'}}</span> </li>
                                    </ul>
                                </div>
                            </Card>
                            </Col>
                            <noData v-if="!projectList.length"
                                    :value="$t('没有查询到相关数据')"></noData>
                        </Row>
                    </div>
                    <div v-if="!loading"
                         class="footer">
                        <Page v-if="pageData.show"
                              size="small"
                              :total="total"
                              :current="pageData.current"
                              :pageSize="pageData.pageSize"
                              :pageSizeOpts="pageData.pageSizeOpts"
                              :placement="pageData.placement"
                              :showTotal="pageData.showTotal"
                              :showElevator="pageData.showElevator"
                              :showSizer="pageData.showSizer"
                              :transfer="pageData.transfer"
                              @on-change="onPageNumChange"
                              @on-page-size-change="onPageSizeChange" />
                    </div>
                    <div v-if="loading"
                         class="custom-loading"
                         style="height: 300px;">
                        <Spin fix>
                            <Icon type="ios-loading"
                                  :size='24'
                                  class="demo-spin-icon-load"></Icon>
                            <div>{{$t('加载中')}}</div>
                        </Spin>
                    </div>
                </div>
            </div>
        </div>
        <!--创建/编辑-->
        <createproject ref="createproject"
                       @refresh="refresh"></createproject>
        <!--配置-->
        <projectset ref="projectset"
                    @refresh="refresh"></projectset>
    </div>
</template>

<script>
import helpInfo from '@c/basic/helpinfo'
import API from '@/service/api'
import noData from '@c/basic/nodata'
import createproject from './components/createproject'
import projectset from './components/projectset'
export default {
    inject: ['reload'],
    name: 'project',
    components: {
        helpInfo,
        noData,
        createproject,
        projectset
    },
    data () {
        return {
            helpData: {
                modelName: this.$t('项目')
            },
            allprojectList: [],
            projectList: [],
            searchValueList: [{ title: this.$t('项目名称'), name: '' }],
            loading: false,
            total: 0,
            pageData: {
                show: true,
                pageWays: 'server', // 前端分页 client, 后端分页 server
                current: 1,
                pageSize: 10,
                pageSizeOpts: [10, 20, 30, 40],
                placement: 'bottom',
                showTotal: true,
                showElevator: true,
                showSizer: true,
                transfer: true
            },
            searchCondition: 'name',
            searchName: '',
            searchList: [{
                value: 'name',
                label: this.$t('项目名称')
            }]
        }
    },
    created () {
        this.init()
    },
    methods: {
        // 初始化数据
        init () {
            this.loading = true
            this.axios.get(this.urlFormat(API.ACCESS_PROJECTS, false), {
                params: {
                    pagesize: this.pageData.pageSize,
                    pagenum: this.pageData.current - 1,
                    orgNameLike: this.searchName || null
                }
            }).then(res => {
                this.loading = false
                this.projectList = res.dataList
                this.total = res.totalRows
            }).catch(e => {
                this.loading = false
            })
        },
        // 搜索
        searchClick () {
            this.pageData.current = 1
            this.searchValueList = [{ title: this.searchCondition, name: this.searchName }]
            this.init()
        },
        // 关闭标签
        handleCloseTags (index) {
            this.pageData.current = 1
            this.searchValueList[0].name = ''
            this.searchName = ''
            this.init()
        },
        // 刷新表单
        refresh () {
            this.init()
        },
        // 创建
        create () {
            this.$nextTick(() => {
                this.$refs.createproject.openModal()
            })
        },
        // 编辑
        editClick (data) {
            this.$nextTick(() => {
                this.$refs.createproject.openModal(data)
            })
        },
        // 设置
        setClick (data) {
            this.$nextTick(() => {
                this.$refs.projectset.openModal(data)
            })
        },
        // 删除
        deleteClick (data) {
            this.$Modal.confirm({
                okText: this.$t('确定'),
                cancelText: this.$t('取消'),
                title: this.$t('确定要删除该项目吗?'),
                content: this.$t('删除无法恢复，该项目下资源将会移动到默认项目。'),
                onOk: () => {
                    this.axios.delete(this.urlFormat(API.ACCESS_PROJECTS_ID, false, [data.orgSid])).then(res => {
                        // this.refresh()
                        this.reload()
                    })
                }
            })
        },
        // 项目总览
        cardClick (data, event) {
            // this.$router.push({
            //     path: '/mgt/dashboard',
            //     query: {
            //         authorityProjectId: data.orgSid
            //     }
            // })
            this.$store.commit('switchProject', data.orgSid)
        },
        // 页码改变
        onPageNumChange (current) {
            this.pageData.current = current
            this.init()
        },
        // 每页条数改变
        onPageSizeChange (pageSize) {
            this.pageData.pageSize = pageSize
            this.init()
        },
        // 获取随机数
        getCustomNum (item) {
            const maxNum = 8
            return item.id % maxNum + 1
        }
    }
}
</script>
<style lang="less" scoped>
.projectList {
    height: 100%;
    background: #f5f6f7;
    .content {
        overflow-y: auto;
        height: calc(~'100% - 50px');
        padding: 0px 15px 15px 15px;
    }
    .ivu-spin-dot {
        display: none;
    }
    .ivu-spin-text {
        display: block;
    }
    .no-pad {
        padding: 0px !important;
        .ivu-card-body {
            padding: 0px !important;
        }
    }
    .tbl-operate {
        padding: 10px 0 0 0;
        text-align: left;
        background: #fff;
        a.disabled {
            pointer-events: none;
            color: #ccc;
        }
        .right {
            float: right;
            font-size: 12px;
            color: #888;
        }
        .colorWait {
            color: #ffa200;
        }
        a {
            // color: #fe6a00;
            font-size: 12px;
            padding: 0 5px;
        }
    }
    .card-main {
        position: relative;
        .operatingBtn {
            position: absolute;
            z-index: 10;
            right: 7px;
            top: 0px;
            height: 35px;
            line-height: 35px;
            display: inline-block;
            cursor: pointer;
            a {
                display: inline-block;
            }
        }
        .card-content {
            padding: 10px;
            display: flex;
            color: #808080;
            font-size: 12px;
            height: 70px;
            line-height: 25px;
            ul {
                width: 100%;
                li {
                    width: calc(~'100% - 0px');
                    span {
                        color: #333;
                    }
                }
            }
        }
    }

    .card-main:hover .operatingBtn {
        display: block;
    }
    .footer {
        padding: 15px;
        text-align: right;
    }
    .ope-pack {
        display: flex;
        justify-content: space-between;
    }
    .top {
        margin: 15px 0 0px 0;
    }
    .card {
        margin: 15px 0 0 0;
    }
    .searchInput {
        width: 383px;
        .status {
            position: absolute;
            right: 54px;
            top: 1px;
            z-index: 10;
            height: 25px;
            width: 250px;
        }
    }
    .tbl-operate {
        padding: 10px;
    }
    .card {
        // margin: 55px 0 0 0;
        position: relative;
    }
    .card.marTop60 {
        margin: 62px 0 0 0;
    }
    .search-tips-card {
        position: relative;
        right: 0;
        margin-top: 5px;
        text-align: right;
    }
}
</style>
<style lang="less">
.projectList .ivu-card-head {
    padding: 0;
    height: 35px;
}
.projectList {
    .custom-loading {
        background: #f5f6f7;
    }
    .ivu-card-bordered {
        border-color: #f5f6f7;
        box-shadow: 0px 3px 3px 3px #f5f5f5;
    }
    .card-main {
        .ivu-card-extra {
            display: none;
        }
    }
    .card-main:hover {
        .ivu-card-extra {
            display: block;
        }
    }
    .ivu-card-body {
        padding: 0;
    }
    .ivu-card-head {
        p {
            height: 35px;
            line-height: 35px;
            padding-left: 7px;
            width: calc(~'100% - 70px');
        }
    }
    .searchInput {
        input {
            height: 32px;
            // border: none;
            box-shadow: none;
            font-size: 12px;
            border-width: 1px 0;
        }
        button {
            border-left: none;
            &:after {
                content: '';
                display: block;
                position: absolute;
                top: 50%;
                right: 32px;
                width: 1px;
                height: 15px;
                background-color: #e9e9e9;
                transform: translateY(-50%);
            }
        }
    }
}
.projectList .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
    font-size: 12px;
}
.projectList .no-data {
    text-align: center;
    line-height: 100px;
    color: #80808;
    margin: 0px 10px 15px 10px;
    font-size: 12px;
}
.projectList .ivu-switch-small.ivu-switch-checked:after {
    left: 14px;
}
.projectList .disabled {
    cursor: not-allowed;
    pointer-events: none;
}
.rc-theme-green .ivu-input-group .ivu-input {
    background: inherit;
}
</style>
